/**
 * Created by satuk on 24.07.17.
 */
import initialState from "../../data";

export const products = (state = initialState, action) => {
  return state;
};



// WEBPACK FOOTER //
// ./src/store/reducers/products.js